import { useAuth } from '@/contexts/AuthContext';
import { UnifiedAdminDashboard } from '@/components/dashboard/UnifiedAdminDashboard';
import { TecnicoDashboard } from '@/components/dashboard/TecnicoDashboard';
import { OrdenesTrabajoProvider } from '@/contexts/OrdenesTrabajoContext';
import maintenanceLogo from '@/assets/maintenance-logo.png';

const Index = () => {
  const { perfil } = useAuth();

  // Show admin dashboard for administrators and gestores (office roles)
  if (perfil?.rol === 'admin' || perfil?.rol === 'gestor') {
    return <UnifiedAdminDashboard />;
  }

  // Show technician dashboard for technicians
  if (perfil?.rol === 'tecnico') {
    return (
      <OrdenesTrabajoProvider>
        <TecnicoDashboard />
      </OrdenesTrabajoProvider>
    );
  }

  // Show welcome screen for other roles
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center space-y-8">
      <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center">
        <img 
          src={maintenanceLogo} 
          alt="Maintenance Hub Logo" 
          className="w-24 h-24 object-contain"
        />
      </div>
      
      <div className="space-y-4">
        <h1 className="text-4xl font-bold bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
          Bienvenido al Sistema de Gestión
        </h1>
        
        <p className="text-xl text-muted-foreground max-w-2xl">
          Sistema de gestión de instalaciones de seguridad con sincronización offline
        </p>
        
        {perfil && (
          <div className="mt-6 p-4 bg-muted/50 rounded-lg">
            <p className="text-lg">
              Hola, <strong className="text-primary">{perfil.nombre}</strong>
            </p>
            <p className="text-sm text-muted-foreground">
              Rol: {(perfil.rol as 'admin' | 'tecnico') === 'admin' ? 'Administrador' : 'Técnico'}
            </p>
          </div>
        )}
        
        <p className="text-muted-foreground mt-8">
          Utiliza el menú lateral para navegar por las diferentes secciones
        </p>
      </div>
    </div>
  );
};

export default Index;
